export default __webpack_public_path__ + "static/media/gallery (5).ae6c306d.png";